import { BankAccountCurrency } from "../collections/BankAccounts/enum";
export const convertCurrency = (from, amount, to) => {
    var _a, _b;
    const rates = JSON.parse(localStorage.getItem("currency-data"));
    const BASE_CURRENCY = BankAccountCurrency.RON;
    if (from === "LEI") {
        from = BankAccountCurrency.RON;
    }
    if (to === "LEI") {
        to = BankAccountCurrency.RON;
    }
    if (from === to) {
        return amount;
    }
    // if from is not ron convert it to ron first
    if (from !== BASE_CURRENCY) {
        if (from === "NIL") {
            amount = 0;
        }
        else {
            const multiplier = rates.find((r) => r._attributes.currency === from);
            amount = amount * Number.parseFloat((_a = multiplier === null || multiplier === void 0 ? void 0 : multiplier._text) !== null && _a !== void 0 ? _a : "0");
        }
    }
    // we're already RON
    if (to === BASE_CURRENCY) {
        return amount;
    }
    const convertDivisor = rates.find((r) => r._attributes.currency === to);
    return amount / Number.parseFloat((_b = convertDivisor === null || convertDivisor === void 0 ? void 0 : convertDivisor._text) !== null && _b !== void 0 ? _b : "1");
};
